import { zoomStore, zoomStoreActions } from '../../../store';

type Direction = -1 | 1;

export const onZoom = (direction: Direction) => {
	const zoomLevel = zoomStore.zoomLevel.get() || 1;
	const [minZoomLevel, maxZoomLevel, zoomDelta] = zoomStore.zoomRanges.get();

	const newZoomLevel = zoomLevel + zoomDelta * direction;

	if (newZoomLevel > maxZoomLevel || newZoomLevel < minZoomLevel) {
		return;
	}

	const nextNewZoomLevel = newZoomLevel + zoomDelta * direction;
	const nextZoomLimit = nextNewZoomLevel > maxZoomLevel || nextNewZoomLevel < minZoomLevel ? direction : 0;

	zoomStoreActions.setZoomLimit(nextZoomLimit);
	zoomStoreActions.setZoomLevel(newZoomLevel);
};
